(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-support"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Opens whichever live-chat widget is installed (Shopify Inbox, Tidio, Crisp, etc.).
    function openChat() {
      try {
        if (window.$crisp) { window.$crisp.push(['do', 'chat:open']); return true; }
        if (window.tidioChatApi && window.tidioChatApi.open) { window.tidioChatApi.open(); return true; }
        if (window.Tawk_API && window.Tawk_API.maximize) { window.Tawk_API.maximize(); return true; }
        if (window.Intercom) { window.Intercom('show'); return true; }
        if (window.fcWidget && window.fcWidget.open) { window.fcWidget.open(); return true; }
        if (window.LiveChatWidget && window.LiveChatWidget.call) { window.LiveChatWidget.call('maximize'); return true; }
        if (window.zE) { window.zE('messenger', 'open'); return true; }
        var toggle = document.querySelector(
          '#shopify-chat, shopify-chat, [data-testid="chat-button"], .shopify-chat-button, [id^="ShopifyChat"], #chat-widget-container button, iframe[title*="chat" i]'
        );
        if (toggle) { (toggle.click ? toggle.click() : toggle.dispatchEvent(new Event('click'))); return true; }
      } catch (e) {}
      return false;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-open-chat]') : null;
      if (!btn) return;
      e.preventDefault();
      openChat();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["egp-coa-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCoa(root) {
      var input = root.querySelector('.coa__search-input');
      if (!input) return;
      var rows = Array.prototype.slice.call(root.querySelectorAll('.coa__row'));
      var empty = root.querySelector('.coa__empty');
      var countNum = root.querySelector('.coa__count-num');

      function apply() {
        var q = input.value.trim().toLowerCase();
        var shown = 0;
        rows.forEach(function (row) {
          var name = row.getAttribute('data-name') || '';
          var match = q === '' || name.indexOf(q) !== -1;
          row.style.display = match ? '' : 'none';
          if (match) shown++;
        });
        if (countNum) countNum.textContent = shown;
        if (empty) {
          if (shown === 0) {
            empty.hidden = false;
            empty.classList.add('coa__empty--show');
          } else {
            empty.hidden = true;
            empty.classList.remove('coa__empty--show');
          }
        }
      }

      input.addEventListener('input', apply);
    }

    function initAll() {
      document.querySelectorAll('.coa').forEach(initCoa);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.coa');
      if (el) initCoa(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="#reviews"]');
      if (!link) return;
      var target = document.getElementById('reviews');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) {
        history.replaceState(null, '', '#reviews');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
